// extracted by mini-css-extract-plugin
export default {"root":"ExerciseModal_root__kWbBh","label":"ExerciseModal_label__AAE8e","notice":"ExerciseModal_notice__AtDrQ"};